export const studentClassRestartDateHeaderFn = () => [
  { field: 'sl_no', headerName: 'Sl No', width: 90 },
  { field: 'admn_no', headerName: 'Admission No', width: 190, sortable: true },
  { field: 'student_name', headerName: 'Student Name', width: 300, toolTipGetter: true, sortable: true },
  { field: 'student_mob_no', headerName: 'Mobile', width: 150 },
  { field: 'class_name', headerName: 'Class', width: 120, sortable: true },
  { field: 'course_name', headerName: 'Course', width: 300, toolTipGetter: true, sortable: true },
  { field: 'course_enrollment_date', headerName: 'Course Enrollment Date', width: 240, sortable: true },
  { field: 'total_sessions', headerName: 'Total Sessions', width: 200, sortable: true },
  { field: 'last_session_date', headerName: 'Last Session Date', width: 200, sortable: true },
  { field: 'course_inactive_date', headerName: 'Inactive Date', width: 180, sortable: true },
  { field: 'course_restart_date', headerName: 'Course Restart Date', width: 200, sortable: true },
  {
    field: 'profile',
    headerName: 'Profile',
    width: 180,
    type: 'action',
    actionType: 'view',
    actionKey: 'student profile',
    buttonName: 'View Profile',
  },
];
